import { Button, Modal } from 'react-bootstrap'
import starCircle from 'assets/images/login-starcircle.svg'
import circle from 'assets/images/login-circle.svg'
import { ModalCloseSVG } from 'assets/svg/ModalSVG/ModalCloseSVG'

function BaseModal({
	show,
	onHide,
	onShow,
	children,
	hideDecor,
	...otherProps
}) {
	return (
		<Modal
			show={show}
			onHide={onHide}
			{...otherProps}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			className="modal-base"
			backdrop={true}
		>
			{children}
			{hideDecor ? null : (
				<img src={starCircle} width="166" alt="" className="circle1" />
			)}
			{hideDecor ? null : (
				<img src={circle} width="110" alt="" className="circle2" />
			)}
			<Button variant="dark" onClick={onHide} className="btn-close">
				<ModalCloseSVG width="32" height="32" viewBox="0 0 32 32" />
			</Button>
		</Modal>
	)
}

export default BaseModal
